"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const state_1 = require("@airstudio/state");
const splitio_1 = require("@splitsoftware/splitio");
class SplitIO extends state_1.Extensions.Abstract {
    constructor() {
        super();
        this.key = 'splitio';
        this.splitNames = [];
        this.userKey = 'unknown';
        this.userAttributes = {};
        this.isOn = false;
        this.selectors.set('isFlagActive', (state, rootState, props) => {
            if (props.flag) {
                if (state[props.flag]) {
                    if (state[props.flag].toUpperCase() === 'ON') {
                        return true;
                    }
                }
            }
            else {
                // tslint:disable-next-line: no-console
                return console.warn('isFlagActive needs a flag attribute in props');
            }
            return false;
        });
        state_1.Bus.onConfigReady(({ splitio: { authorizationKey, splitNames } }) => {
            if (!authorizationKey) {
                // tslint:disable-next-line: no-console
                return console.warn('Splitio extension is activated but backend config did not provide a `splitio.authorizationKey` value');
            }
            this.authorizationKey = authorizationKey;
            if (!splitNames) {
                // tslint:disable-next-line: no-console
                return console.warn('Splitio extension is activated but backend config did not provide a `splitio.splitNames` value');
            }
            this.splitNames = splitNames;
        });
        state_1.Bus.onUserReady(({ userId }) => {
            this.userKey = userId;
            this.init();
        });
    }
    init() {
        this.dispatchRequest(); // In the store, change the state of the extension to isLoading
        if (!this.client) {
            this.client = splitio_1.SplitFactory({
                core: { authorizationKey: this.authorizationKey, key: this.userKey },
                startup: { readyTimeout: 1.5 },
            }).client();
            this.on();
        }
        return this;
    }
    async refresh() {
        const treatments = this.client.getTreatments(this.splitNames, this.userAttributes);
        this.dispatchSuccess(treatments); // Update the store for the current extension
        return treatments;
    }
    on() {
        if (this.isOn) {
            return;
        }
        this.client.on(this.client.Event.SDK_READY, this.refresh.bind(this));
        this.client.on(this.client.Event.SDK_UPDATE, this.refresh.bind(this));
        this.isOn = true;
        return this;
    }
    off() {
        if (!this.isOn) {
            return;
        }
        this.client.off(this.client.Event.SDK_READY, this.refresh.bind(this));
        this.client.off(this.client.Event.SDK_UPDATE, this.refresh.bind(this));
        this.isOn = false;
        return this;
    }
}
exports.SplitIO = SplitIO;
//# sourceMappingURL=index.js.map